import React, { useEffect, useRef } from "react";

import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { useMemo } from "react";

function MapView(props) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_MAPS_KEY,
  });
  const center = useMemo(() => ({ lat: props.lat, lng: props.lng }), []);
  return (
    <>
      {!isLoaded ? (
        <h1>Loading...</h1>
      ) : (
        <GoogleMap
          mapContainerClassName="map-container"
          mapContainerStyle={{
            height: "100%",
            width: "100%",
          }}
          center={center}
          zoom={14}
        >
          <Marker position={{ lat: props.lat, lng: props.lng }} />
        </GoogleMap>
      )}
    </>
  );
}

// function MapView() {
//   const mapRef = useRef();
//   const googleMapsAPI = GoogleMapsClient({ key: process.env.REACT_APP_MAPS_KEY });
//   let map;
//   useEffect(() => {
//     map = new googleMapsAPI.Map(mapRef, {
//       center: { lat: -34.397, lng: 150.644 },
//       zoom: 8,
//     });
//   }, []);
//   return <div ref={map} style={{ width: "100%", height: "100%" }}></div>;
// }

export default MapView;
